/**
 * FooterIcons
 *
 * Monochrome inline SVG icons for the site footer. They inherit the
 * current text color via `stroke="currentColor"` / `fill="currentColor"`
 * so they follow the link's color transition to gold on hover without
 * extra CSS wiring.
 *
 * Kept as inline SVG (no icon library) to avoid a dependency and to
 * keep the icons tiny (~200 bytes each after minify) and drift-proof
 * against library version bumps.
 */

import type { SVGProps } from 'react'

type IconProps = Omit<SVGProps<SVGSVGElement>, 'children'>

const BASE: IconProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
}

export function IconMail(props: IconProps) {
  return (
    <svg {...BASE} {...props}>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3 7l9 6 9-6" />
    </svg>
  )
}

export function IconMapPin(props: IconProps) {
  return (
    <svg {...BASE} {...props}>
      <path d="M12 21s-7-6.5-7-12a7 7 0 0114 0c0 5.5-7 12-7 12z" />
      <circle cx="12" cy="9" r="2.5" />
    </svg>
  )
}

export function IconNews(props: IconProps) {
  return (
    <svg {...BASE} {...props}>
      <path d="M4 5h13v14H4z" />
      <path d="M17 8h3v11a2 2 0 01-2 2h-1" />
      <path d="M7 9h7M7 12h7M7 15h5" />
    </svg>
  )
}

export function IconScroll(props: IconProps) {
  return (
    <svg {...BASE} {...props}>
      <path d="M8 4h9a2 2 0 012 2v2h-3" />
      <path d="M5 8v9a2 2 0 002 2h9a2 2 0 002-2V8H8a2 2 0 00-2 2v0" />
      <path d="M10 12h6M10 15h4" />
    </svg>
  )
}

export function IconFacebook(props: IconProps) {
  return (
    <svg {...BASE} fill="currentColor" stroke="none" {...props}>
      <path d="M13.5 21v-8h2.7l.4-3.1h-3.1V7.9c0-.9.3-1.5 1.6-1.5h1.7V3.6c-.3-.05-1.3-.15-2.4-.15-2.4 0-4 1.5-4 4.2v2.3H8v3.1h2.4V21h3.1z" />
    </svg>
  )
}
